var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProject3ShildSuperresolution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1660_19774)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5126 5.3416C11.4329 6.8627 10.8517 8.20098 9.86966 9.36348C9.25091 10.0971 8.47982 10.6361 7.65247 11.1049C7.19076 11.365 6.73841 11.6393 6.28372 11.9135C6.09388 12.026 5.91576 12.0307 5.72591 11.9158C5.0931 11.5385 4.45091 11.1752 3.82279 10.7861C1.85169 9.5627 0.747786 7.78613 0.489974 5.48692C0.459505 5.22207 0.461849 4.95254 0.457161 4.68535C0.452474 4.41817 0.457161 4.15098 0.457161 3.88379C0.457161 3.38223 0.457161 2.87832 0.457161 2.37676C0.457161 2.03223 0.632943 1.86582 0.97513 1.84942C2.63919 1.76504 4.16966 1.28223 5.51732 0.274416C5.58294 0.225197 5.64154 0.16426 5.70482 0.112697C5.89232 -0.037303 6.11497 -0.037303 6.30013 0.115041C7.47669 1.08301 8.84779 1.5916 10.3454 1.79551C10.5868 1.82832 10.8329 1.8377 11.0767 1.85176C11.3556 1.86817 11.5454 2.04629 11.5454 2.32754C11.5408 3.33301 11.5665 4.33848 11.5126 5.3416Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1660_19774"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "current"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject3ShildSuperresolution);
export default __webpack_public_path__ + "static/media/project3_shild_superresolution.976ebd45e38359400b2a5509a648296f.svg";
export { ForwardRef as ReactComponent };